import React from 'react';

interface LoadingStateProps {
  message?: string;
}

const LoadingState: React.FC<LoadingStateProps> = ({
  message = 'Loading...',
}) => (
  <div className="flex flex-col items-center justify-center py-16" aria-busy="true">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-400" />
    <p className="mt-4 text-secondary-400">{message}</p>
  </div>
);

export default LoadingState;
